import { ConsentDocumentContentModel } from '../generated/types/ConsentDocumentContentModel';

const defaultConsentDocumentContentMock: ConsentDocumentContentModel = {
  _content_type_uid: 'consent_document',
  client_application: { client_value: ['hcp-web'] },
  title: 'Consent Document',
  version: '1',
  consent_type: 'EULA',
  header: 'End-user license agreement (EULA)',
  subheader: 'Please read and agree to our EULA. This step is required to use our services.',
  body_text_md: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  countries: {
    country: ['ZZ'],
  },
  uid: '',
  metadata: {},
};

const create = (partial?: Partial<ConsentDocumentContentModel>): ConsentDocumentContentModel => ({
  ...defaultConsentDocumentContentMock,
  ...partial,
});

export const ConsentDocumentContentModelMock = { create };
